// src/App.js
import React, {useEffect} from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';

// Eigene Imports:
import { ChartFWurfOnly } from './pages/FWurf';
import { ChartGWurfOnly } from './pages/GWurf';
import KombinierteAnsicht from './pages/KombinierteAnsicht';
import ChartCWurfOnly from "./pages/CWurf"; // Standardimport

// // Beispiel-Startseite
// function Home() {
//     return (
//         <div style={{ padding: 20 }}>
//             <h2>Willkommen im Welpen-Gewichts-Tracker!</h2>
//             <p>Wähle einen Wurf oder schau alle zusammen an:</p>
//             <ul>
//                 <li>
//                     <Link to="/f-wurf">F-Wurf (einzeln)</Link>
//                 </li>
//                 <li>
//                     <Link to="/g-wurf">G-Wurf (einzeln)</Link>
//                 </li>
//                 <li>
//                     <Link to="/kombiniert">F + G + Soll (kombiniert)</Link>
//                 </li>
//             </ul>
//         </div>
//     );
// }

// Haupt-App mit Routen
function App() {

    useEffect(() => {


        if (window.self !== window.top || window !== window.parent) {
            document.body.classList.add('iframe-view');

            // Funktion, die die Höhe an die umgebende Seite sendet
            const sendHeight = () => {
                setTimeout(() => {
                    const measuredHeight = Math.max(
                        document.body.scrollHeight,
                        document.documentElement.scrollHeight,
                        document.body.offsetHeight,
                        document.documentElement.offsetHeight,
                        document.body.clientHeight,
                        document.documentElement.clientHeight
                    );

                    window.parent.postMessage({ height: measuredHeight }, '*');
                }, 200)
            };

            // Höhe initial senden
            sendHeight();

            // Optionale Aktualisierung bei Fensteränderung
            window.addEventListener('resize', sendHeight);

            // Bereinigen des Events
            return () => {
                window.removeEventListener('resize', sendHeight);
            };
        } else {
            document.body.classList.remove('iframe-view');

            // Bereinigen des Events
            return () => {};
        }


    }, []);

    return (
        <BrowserRouter>
            {/* Optionales Menü oder Link-Liste oben */}
            {/*<nav style={{ backgroundColor: '#eee', padding: '10px' }}>*/}
            {/*    /!*<Link to="/" style={{ marginRight: 15 }}>*!/*/}
            {/*    /!*    Home*!/*/}
            {/*    /!*</Link>*!/*/}
            {/*    <Link to="/" style={{ marginRight: 15 }}>*/}
            {/*        F-Wurf Indyo Rácaron*/}
            {/*    </Link>*/}
            {/*    <Link to="/g-wurf" style={{ marginRight: 15 }}>*/}
            {/*        G-Wurf Lobos's Legend*/}
            {/*    </Link>*/}
            {/*    <Link to="/kombiniert">Kombiniert</Link>*/}
            {/*</nav>*/}

            <Routes>
                {/*<Route path="/" element={<Home />} />*/}
                <Route path="/" element={<ChartFWurfOnly />} />

                {/* Einzelner C-Wurf */}
                <Route path="/c-wurf" element={<ChartCWurfOnly />} />

                {/*/!* Einzelner F-Wurf *!/*/}
                {/*<Route path="/f-wurf" element={<ChartFWurfOnly />} />*/}

                {/* Einzelner G-Wurf */}
                <Route path="/g-wurf" element={<ChartGWurfOnly />} />

                {/*/!* Kombinierte Ansicht: F + G + Soll *!/*/}
                <Route path="/kombiniert" element={<KombinierteAnsicht />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
